module.exports = __webpack_public_path__ + "static/img/user_avatar06.59c6c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_avatar06.png
// module id = UkCY
// module chunks = 1